// extracted by mini-css-extract-plugin
export default {"container":"FirstAccess_container__SgDMs","page":"FirstAccess_page__9Cnkz"};